const NEWSALT = 'BtvNgY/+ZEzLWQrwLU';

export default NEWSALT;
